module.exports = __webpack_public_path__ + "static/media/oxy-snacks.aa00849b.pdf";